module.exports = __webpack_public_path__ + "static/media/amil.cbb4605f.jpg";